import { UserProfileType } from '../modules/login/services/user-api.service';

export function getCookie(name: string) {
  return document.cookie.split(';').some((c) => {
    return c.trim().startsWith(name + '=');
  });
}

export function deleteCookie(name: string, path: string, domain: string) {
  if (getCookie(name)) {
    document.cookie =
      name +
      '=' +
      (path ? ';path=' + path : '') +
      (domain ? ';domain=' + domain : '') +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
}

export function eraseCookie(name: string) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

export function getProperty<T, K extends keyof T>(obj: T, key: K) {
  return obj[key];
}

export function isPlural(count: number): boolean {
  return count !== 1;
}

export function getFilenameFromContentDisposition(disposition: string | null): string | null {
  if (!disposition) return null;
  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
  return matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : null;
}

export function isUserAdminOrLegal(userProfileType: UserProfileType | undefined): boolean {
  return userProfileType === UserProfileType.Admin || userProfileType === UserProfileType.Legal;
}

export function isUserSalesOrProcurement(userProfileType: UserProfileType | undefined): boolean {
  return (
    userProfileType === UserProfileType.Sales || userProfileType === UserProfileType.Procurement
  );
}

export function getOneTableMenuItemHtml(
  id: string,
  event: string,
  icon: string,
  title: string,
  disabled: boolean = false,
  withTitle = false,
): string {
  let html = '';
  html += `<span class="extra-menu-item ${disabled ? 'disabled' : ''}" ${event}='${id}'>`;
  html += `<span ${event}='${id}' class="table-menu-icon icon-${icon}" title='${title}'> </span> ${withTitle ? title : ''}`;
  html += '</span>';

  return html;
}
